module.exports = "https://cdn.realtymogul.com/static/media/press_logo_forbes.76923667.jpg";